<template>
  <div class="pa-4">
    <v-row justify="space-between">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">{{ 'Nysc Details'.toUpperCase() }}</div>
      </v-col>
    </v-row>
    <v-form ref="form" v-model="dataValid">
      <v-alert type="warning" class="mt-4" v-if="!noHeader">
        Make sure to provide correct information as editing will not be allowed after submission
      </v-alert>
      <v-row class="pt-8">
        <v-col cols="12" md="4">
          <v-select :items="countries" item-text="name" item-value="id" outlined dense label="Country" required v-model="selectedCountry" :rules="textRules" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="states" item-text="name" item-value="id" outlined dense label="State" required v-model="obj.stateId" :rules="textRules" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select dense outlined placeholder="Date" :items="dates" v-model="obj.year" required :rules="textRules" :disabled="!canEdit"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Address" required :rules="textRules" v-model="obj.location" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{ noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-btn color="error" depressed @click="$refs.form.reset()" v-if="userData == null && canEdit && !noHeader">Reset</v-btn>
      <v-btn color="primary" depressed @click="saveData" :disabled="!dataValid" v-if="canEdit">{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" depressed @click="success" v-if="userData != null || !canEdit">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>

</template>


<script>
import DateUtil from "@/shared/DateUtil";
import ValidationRules from "@/shared/ValidationRules";
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import StudentStatus from "@/shared/StudentStatus";

export default {
  name: "NyscDetails",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data: () => ({
    obj: {},
    dates: DateUtil.getYearsArray(1970),
    textRules: ValidationRules.textRules,
    states: [],
    countries: [],
    selectedCountry: null,
    dataValid: true,
    userData: null,
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
  }),

  watch: {
    userData: function (val){
      if(val != null){
        // this.success()
      }
    },

    getUser: function(){
      if(this.checkRequirement()) {
        this.success()
        return
      }

      if(this.getUser != null)
        this.loadNYCEDetails()
    },

    selectedCountry: function(newVal){
      if(newVal != null){
        this.selectedState = null
        this.states = []
        this.loadStates()
      }
    },
  },

  computed: {
    ...mapGetters(['getUser']),
    canEdit: function(){
      // status still not upto application complete
      return this.getUser != null && (StudentStatus[this.getUser.studentStatus].value < StudentStatus.APPLICATION_COMPLETE.value)
    }
  },

  methods: {
    success() {
      this.$emit("success")
      // this.$router.push('dashboard')
    },

    checkRequirement(){
      return this.getUser != null && this.getUser.admission.applicationType.nyscDetailsEnabled === false
    },

    loadNYCEDetails(){
      this.loading = true;
      Api.applicants.getNYCEDetails(this.getUser.userId)
          .then(res => {
            this.userData = res.data
            this.prefillData()
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    check(){
      Api.applicants.nextToNYSCUpdate(this.getUser.id).then((res) => {
        this.loading = true
        this.$store.commit("setCurrentUser", res.data);
        this.loading = false;
      }).catch((err) => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false )
    },

    saveData(){
      this.loading = true
      Api.applicants.nyscUpdate(this.getUser.id, this.obj)
          .then(() => {
            this.message = 'NYCS details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    prefillData(){
      if(this.userData != null){
        let u = this.userData
        if(u.state != null){
          this.obj.stateId = u.state.id
          this.selectedCountry = u.state.country.id
        }

        this.obj.location = u.location
        this.obj.year = +u.year
      }
    },

    loadCountries(){
      this.loading = true
      Api.nationality.getCountries()
          .then(res => {
            this.countries = res.data
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadStates(){
      this.loading = true
      this.states = []
      Api.nationality.getStates(this.selectedCountry)
          .then(res => {
            this.states = res.data
            // update state object
            if(this.getInformation != null)
              this.selectedState = this.getInformation.state.id
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },
  },

  created() {
    this.loadCountries()
    if(this.getUser != null){
      if(this.checkRequirement()){
        this.success()
        return
      }

      else {
        this.check();
        this.loadNYCEDetails();
      }

    }
    this.noHeader && this.$emit('update-title', "NYSC Details")
  }
}
</script>
